var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chainId == 9001)?_c('v-mintevmos'):_vm._e(),(_vm.chainId == 9000)?_c('v-mintevmostest'):_vm._e(),(_vm.chainId == 280)?_c('v-mintzksync'):_vm._e(),(_vm.chainId == 324)?_c('v-mintzksyncmain'):_vm._e(),(_vm.chainId == 534353)?_c('v-mintscroll'):_vm._e(),(_vm.chainId == 534351)?_c('v-mintscrollsepolia'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }